import 'semantic-ui-css/semantic.min.css'
import React, { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom"
import './App.css';
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import OurTeam from "./pages/OurTeam";
import ContactUsPage from "./pages/ContactUsPage";
import NoPage from "./pages/NoPage";
import TenantLogin from "./pages/TenantLogin"
import OwnerLogin from "./pages/OwnerLogin"
import Pricing from "./pages/Pricing";
import OurServices from "./pages/OurServices";
import RealHelp from "./pages/RealHelp";
import WeServe from "./pages/WeServe"
import BRPage from "./pages/BRPage"
import { Helmet } from 'react-helmet-async'
import HRedirect from "./pages/redirects/HarrisburgRedirect"
import Listing from "./pages/Listing";
import Short from './pages/ShortTermListing';
import ShortListingDetail from "./pages/ShortListingDetail";
import ListingPreference from "./pages/ListingPreference";
import ListingDetail from "./pages/ListingDetail";
import CommercialListing from "./pages/CommercialListing";
import CommercialListingDetail from "./pages/CommercialListingDetail";
import StorageListing from "./pages/StorageListing";
import StorageListingDetail from "./pages/StorageListingDetail";
import CListing from "./pages/CommercialListing";
import SListing from "./pages/StorageListing";
import Policy from "./pages/Policy";
import Terms from "./pages/Terms";

const App = () => {

  return (
      <BrowserRouter>
      <Helmet>
        <head>Delta Property Management Group</head>
        <meta name="description" content="Welcome to Delta Property Management Group, LLC. 
        A Harrisburg Area Property Management Group. Delta PMG is a reliable partner that offers
        services for landlords by landlords. We specialize in managing residential properties aswell 
        as commercial properties."/>
        <link rel="canonical" href="/" />
      </Helmet>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="lander" element={<Home />} />
          <Route path="about-us/our-team" element={<OurTeam />} />
          <Route path="contact-us" element={<ContactUsPage />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="tenant-login" element={<TenantLogin />} />
          <Route path="residential-listings" element={<Listing />} />
          <Route path="/short-term-listings" element={<Short />} />
          <Route path="/short-term-listings/:listingId" element={<ShortListingDetail />} />
          <Route path="/residential-listings/:listingId" element={<ListingDetail />} />
          <Route path="/listing-preferences" element={<ListingPreference />} />
          <Route path="commercial-listings" element={<CListing />} />
          <Route path="/commercial-listings" element={<CommercialListing />} />
          <Route path="/commercial-listings/:listingId" element={<CommercialListingDetail />} />
          <Route path="/storage-listings/:listingId" element={<StorageListingDetail />} />
          <Route path="storage-listings" element={<SListing />} />
          <Route path="owner-login" element={<OwnerLogin />} />
          <Route path="*" element={<NoPage />} />
          {/* <Route path="real-estate-help" element={<RealHelp />} /> */}
          <Route path="about-us/areas-we-serve" element={<WeServe />} />
          <Route path="harrisburg-area" element={<HRedirect />} />
          <Route path="brokers-realtors" element={<BRPage />} />
          <Route path="privacy-policy" element={<Policy />} />
          <Route path="toc" element={<Terms />} />
          <Route path="inquiring-owners/our-services" element={<OurServices />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;